"use client";
import React from "react";
import styles from "../css/medical-aid-modal.module.css";
import Button from "../../../../components/Button";

export default function MedicalAidModal({ onClose, onAction }) {
  return (
    <div className={`${styles.modalOverlay} ${styles.show}`}>
      <div className={styles.modalContent}>
        <h2 className={styles.modalHeading}>Available Options</h2>
        <p className={styles.modalBody}>
          Please select an action for Medical Aid payment:
        </p>

        <div className={styles.buttonContainer}>
          <Button onClick={() => onAction("reselect")}>Reselect Drug</Button>
          <Button onClick={() => onAction("amend")}>Amend Drug Price</Button>
          <Button onClick={() => onAction("ignore")}>Ignore RP</Button>
        </div>
      </div>
    </div>
  );
}
